import {combineReducers} from 'redux';

import episodes from './episodes';
import stories from './stories';

export default combineReducers({
  episodes,
  stories,
});
